import { Card } from 'antd';
import { ReactElement, useCallback } from 'react';
import styled from 'styled-components';

import { documentApi } from '../../../../api/apiClient';
import { DocumentMultiReceiptEntity } from '../../../../generated-api';
import { useDocument } from '../../../../store/useDocumentListStore';
import { notifyError, notifySuccess } from '../../../../utils/notification';
import { ResultPageDocument } from '../../defs/types';
import ReceiptTable from '../ReceiptTable';
import { IndividualDeleteButton } from './IndividualDeleteButton';

const ExpandRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const ButtonWrapper = styled.div`
  margin-bottom: 12px;
`;
const TableWrapper = styled.div`
  flex: 1;
`;

interface Props {
  record: ResultPageDocument<DocumentMultiReceiptEntity>;
}
export function ExpandTable({ record }: Props): ReactElement {
  const { document_id: documentId, group_id: groupId } = record;

  const { setPatchedDocument } = useDocument(groupId, documentId);

  const onConfirmDelete = useCallback(
    async (index: number) => {
      try {
        const updatedReceipts = record.latest_revision.receipts.filter((_, i) => i !== index);
        const response = await documentApi.documentControllerPatchDocument(groupId, documentId, {
          edited_ocr_result: {
            ...record.latest_revision,
            receipts: updatedReceipts,
          },
        });
        setPatchedDocument(response.data);
        notifySuccess('読取り結果を削除しました。');
      } catch (error) {
        console.error('Failed to delete receipt:', error);
        notifyError('読取り結果の削除に失敗しました。');
      }
    },
    [documentId, groupId, record.latest_revision, setPatchedDocument]
  );

  return (
    <>
      {record.latest_revision.receipts.map((receipt, receiptIndex) => (
        <Card key={receiptIndex}>
          <ExpandRow>
            <ButtonWrapper>
              <IndividualDeleteButton index={receiptIndex} onConfirmDelete={onConfirmDelete} />
            </ButtonWrapper>
            <TableWrapper>
              <ReceiptTable receipt={receipt} />
            </TableWrapper>
          </ExpandRow>
        </Card>
      ))}
    </>
  );
}
